export enum RouteEnum {
  API_TESTER = 'api-tester',
  CREATE_KEYS = 'create-key',
  DASHBOARD = 'dashboard',
  INTROSPECT_KEY = 'introspect-key',
  OIDC_TOKENS = 'oidc-tokens'
}